import { HiListBullet } from "react-icons/hi2";

export const TasksIcon = ({ width, height, color, ...props }) => (
  <HiListBullet
    size={width || height || 25}
    color={color || "currentColor"}
    {...props}
  />
);
